import { render, staticRenderFns } from "./Hero5.vue?vue&type=template&id=1f2d8015&"
import script from "./Hero5.vue?vue&type=script&lang=js&"
export * from "./Hero5.vue?vue&type=script&lang=js&"
import style0 from "./Hero5.vue?vue&type=style&index=0&id=1f2d8015&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports